enum Provider {
  ARMENIA = "am",
  BELARUS = "by",
  TFOS = "za",
  UAE = "ae",
  DEFAULT = "хх",
}

export default Provider;
